import Url from "app/config/endpoint";

export function getBaseUrl() {
  const { hostname } = window.location;
  let apiUrl;

  switch (hostname) {
    case "localhost":
      apiUrl = Url.localhost;
      break;

    case "backoffice-stg.cpfltotal.com.br":
    case "d343sz9bd9xkr7.cloudfront.net":
      apiUrl = Url.stage;
      break;

    case "backoffice.cpfltotal.com.br":
    case "dgtqaoclmr4za.cloudfront.net":
      apiUrl = Url.production;
      break;

    default:
      apiUrl = Url.localhost;
  }

  return apiUrl;
}
